import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "form-group text-start",
  id: "password_input"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "input-group input-group-merge" }
const _hoisted_6 = ["id", "placeholder", "type"]
const _hoisted_7 = { class: "invalid-feedback" }

import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    model: { default: () => ({}) },
    label: { default: "Password" },
    placeholder: { default: "Enter your password" },
    errorMsg: { default: "Por favor, preencha este campo corretamente" },
    required: { type: Boolean, default: false },
    id: {}
  },
  setup(__props: any) {

const props = __props;

// EXCLUSIVO DO MAIN (o TextInput do pro já faz assim): mostra a mensagem do schema/validação
const errorMessage = computed(() =>
  props.model && props.model.$errors
    ? props.model.$errors.find((e: any) => e)?.$message || props.errorMsg
    : props.errorMsg,
);

const passwordFieldType = ref("password");

const togglePassword = () => {
  passwordFieldType.value =
    passwordFieldType.value == "password" ? "text" : "password";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.label) + " ", 1),
            (__props.required)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "labelContentEnd")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.model.$model) = $event)),
        id: __props.id || undefined,
        maxlength: 30,
        class: _normalizeClass([{ 'is-invalid': __props.model.$error }, "form-control border-right-0"]),
        placeholder: __props.placeholder,
        type: passwordFieldType.value
      }, null, 10, _hoisted_6), [
        [_vModelDynamic, __props.model.$model]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["input-group-text cursor-pointer", { 'border-danger': __props.model.$error }])
      }, [
        _createElementVNode("i", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePassword())),
          class: _normalizeClass(["fas text-muted", {
        'fa-eye': passwordFieldType.value == 'text',
        'fa-eye-slash': passwordFieldType.value == 'password',
      }])
        }, null, 2)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("small", null, _toDisplayString(errorMessage.value), 1)
      ])
    ])
  ]))
}
}

})